var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_2653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 8.70002C11.3432 8.84445 11.0256 8.91457 10.7055 8.8975C10.3853 8.88044 10.0841 8.77734 9.8572 8.60712C9.63025 8.43691 9.49278 8.21102 9.47003 7.97091C9.44728 7.7308 9.54077 7.49259 9.73334 7.30002L15.0667 3.30002C15.3159 3.11679 15.651 3.01416 16 3.01416C16.349 3.01416 16.6841 3.11679 16.9333 3.30002L22.2667 7.30002C22.4593 7.49259 22.5527 7.7308 22.53 7.97091C22.5072 8.21102 22.3698 8.43691 22.1428 8.60712C21.9159 8.77734 21.6147 8.88044 21.2945 8.8975C20.9744 8.91457 20.6568 8.84445 20.4 8.70002L16 5.40002L11.6 8.70002ZM11.6 15.3C11.3432 15.1556 11.0256 15.0855 10.7055 15.1025C10.3853 15.1196 10.0841 15.2227 9.8572 15.3929C9.63025 15.5631 9.49278 15.789 9.47003 16.0291C9.44728 16.2692 9.54077 16.5074 9.73334 16.7L15.0667 20.7C15.6 21.1 16.4 21.1 16.9333 20.7L22.2667 16.7C22.4593 16.5074 22.5527 16.2692 22.53 16.0291C22.5072 15.789 22.3698 15.5631 22.1428 15.3929C21.9159 15.2227 21.6147 15.1196 21.2945 15.1025C20.9744 15.0855 20.6568 15.1556 20.4 15.3L16 18.6L11.6 15.3Z",
    fill: "#FFFDFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_2653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcons);
export default __webpack_public_path__ + "static/media/arrow-icons.ed7b30f249471b71dfb3e2f62e9ae0d7.svg";
export { ForwardRef as ReactComponent };